import { render, staticRenderFns } from "./environmentalInfo.vue?vue&type=template&id=0b9a3d21&scoped=true"
import script from "./environmentalInfo.vue?vue&type=script&lang=js"
export * from "./environmentalInfo.vue?vue&type=script&lang=js"
import style0 from "./environmentalInfo.vue?vue&type=style&index=0&id=0b9a3d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a3d21",
  null
  
)

export default component.exports